import {proposalrequest} from '@mep/pae-commons';

const {PROPOSAL_STATUS} = proposalrequest;

export const PROPOSAL_STATUS_APPEARANCE = {
  [PROPOSAL_STATUS.DRAFT]: {color: 'gray'},
  [PROPOSAL_STATUS.ARCHIVED]: {color: 'gray'},
  [PROPOSAL_STATUS.EXPIRED]: {color: 'gray'},
  [PROPOSAL_STATUS.ASSIGNED]: {color: 'blue'},
  [PROPOSAL_STATUS.SENT]: {color: 'blue'},
  [PROPOSAL_STATUS.IN_REVIEW]: {color: 'blue'},
  [PROPOSAL_STATUS.REVIEWED]: {color: 'orange'},
  [PROPOSAL_STATUS.VALIDATED]: {color: 'green'},
  [PROPOSAL_STATUS.ACCEPTED]: {color: 'green'},
  [PROPOSAL_STATUS.REJECTED]: {color: 'red'},
  [PROPOSAL_STATUS.CANCELED]: {color: 'red'},
  [PROPOSAL_STATUS.DISSOLVED]: {color: 'red'},
  [PROPOSAL_STATUS.DISMISS]: {color: 'red'},
  [PROPOSAL_STATUS.ON_DISSOLVE_PROCESS]: {color: 'orange'},
};
